import { graphql, useStaticQuery } from 'gatsby';
import { getPDPProductData } from 'utils/helpers';
import { ProductVariants, PromoDataResult } from 'utils/types';

const useProductData = (
  allContentfulPdpPage: PromoDataResult,
  productVariants: ProductVariants,
  pageSlug: string = '',
  isSinglePdp: boolean = false,
) => {
  const { allReviews } = useStaticQuery(graphql`
    query {
      allReviews {
        nodes {
          product_name
          product_page_id
          average_rating
          native_review_count
          question_count
          rating_histogram
          recommended_ratio
          review_count
          syndicated_review_count
        }
      }
    }
  `);

  const productData = getPDPProductData(
    allContentfulPdpPage,
    productVariants,
    allReviews,
    pageSlug,
    isSinglePdp,
  );

  return productData;
};
export default useProductData;
